module.exports = __webpack_public_path__ + "static/media/tbi.bfcab02c.png";